import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './pages/Login';
import BusinessPicker from './pages/BusinessPicker';
import Dashboard from './pages/DashboardModern';

function PrivateRoute({ children }: { children: JSX.Element }) {
  const { token, pendingBusinesses } = useAuth();
  if (!token && !pendingBusinesses) return <Navigate to="/login" replace />;
  if (pendingBusinesses) return <Navigate to="/select-business" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/select-business" element={<BusinessPicker />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
